import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useInfoModal } from "../Context/InfoModalProvider";
//import { ModalSuccessIcon } from "./Icons/ModalSuccessIcon";
import { t } from "i18next";

const VersionChecker: React.FC = () => {
    const navigate = useNavigate();
    const { showInfo } = useInfoModal();

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch("/version.json", { cache: "no-store" });
                if (!response.ok) throw new Error("Could not fetch version");

                const latestVersion: { version: string } = await response.json();
                const cachedVersion = localStorage.getItem("app_version");

                if (cachedVersion && cachedVersion !== latestVersion.version) {

                    await showInfo(
                        <>
                        {/*<div className="flex justify-center mb-2"><ModalSuccessIcon /></div>*/}
                            <div className="text-center">{t("The new version is available!")}</div>
                        </>,
                        (t("Update") as string)
                    );


                    window.history.replaceState(null, "", "/");

                    if ('caches' in window) {
                        caches.keys().then(names => {
                            names.forEach(name => caches.delete(name));
                        });
                    }


                    if ("serviceWorker" in navigator) {
                        navigator.serviceWorker.getRegistrations().then((registrations) => {
                            registrations.forEach((registration) => {
                                registration.unregister();
                            });
                        });
                    }

                    window.location.replace(window.location.pathname + "?t=" + new Date().getTime());
                }

                localStorage.setItem("app_version", latestVersion.version);
            } catch (error) {
                console.error("Error while checking the new version", error);
            }
        };

        checkVersion();

    }, [navigate, showInfo]);

    return null;
};

export default VersionChecker;
